__turbopack_context__.v({
  "icon": "ContactUsButton-module__i9hpyq__icon",
  "label": "ContactUsButton-module__i9hpyq__label",
  "labelCompact": "ContactUsButton-module__i9hpyq__labelCompact",
});
